import {
	Component,
	OnDestroy,
	OnInit,
	ChangeDetectionStrategy,
} from '@angular/core';
import { LegacyApiService } from '@lmc-app/core/services/legacy-api.service';
import { CustomFunctionService } from '../../../custom-function.service';
import { Router, RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { selectUser, State } from '@lmc-app/store';
import { Subject, takeUntil } from 'rxjs';
import { User } from '@lmc-app/shared/interface/user.interface';
import { NgIf, NgFor, DatePipe } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
	selector: 'app-interviewerqueue',
	templateUrl: './interviewerqueue.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./interviewerqueue.component.scss'],
	imports: [NgIf, NgFor, RouterLink, NgxPaginationModule, DatePipe],
})
export class InterviewerqueueComponent implements OnInit, OnDestroy {
	private readonly _onDestroy = new Subject<void>();

	constructor(
		private apiService: LegacyApiService,
		private customFunction: CustomFunctionService,
		private _routerLink: Router,
		private store: Store<State>
	) {}

	timestamp = Date();

	loanInterviewsArray: [];

	p: Number; // Pagination 0 call attempts
	count: Number; // Pagination

	ngOnInit(): void {
		this.store
			.select(selectUser)
			.pipe(takeUntil(this._onDestroy))
			.subscribe((user: User | null) => {
				if (user) {
					this.fetchUnderwritingRLI();
					this.p = 1;
					this.count = 20;
				}
			});
	}

	ngOnDestroy() {
		this._onDestroy.next();
		this._onDestroy.complete();
	}

	fetchUnderwritingRLI() {
		this.apiService.getDealsCreatedUnderwritingRLI().subscribe((res) => {
			if (res.message.statusCode === 200) {
				let arr = JSON.parse(res.message.body);
				this.loanInterviewsArray = arr.data;
			}
		});
	}
	refresh() {
		window.location.reload();
	}
}
